<template>
  <div class="recent-posts">
    <h4 class="recent-title">آخر المنشورات</h4>
    <ul class="recent-list" v-if="recentPosts.length > 0">
      <li 
        v-for="post in recentPosts" 
        :key="post.id" 
        class="recent-item"
        @click="handlePostClick(post)"
      >
        <span class="post-title">{{ post.title || 'بدون عنوان' }}</span>
        <span class="post-type">{{ getTypeLabel(post.type) }}</span>
      </li>
    </ul>
    <div v-else class="no-posts">
      لا توجد منشورات حديثة
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { getDatabase, ref as dbRef, get } from "firebase/database"

const router = useRouter()

const recentPosts = ref([])
const loading = ref(false)
const error = ref(null)

const fetchRecentPosts = async () => {
  loading.value = true
  error.value = null
  
  try {
    const database = getDatabase()
    const recentsRef = dbRef(database, 'recents')
    const snapshot = await get(recentsRef)
    
    if (snapshot.exists()) {
      const data = snapshot.val()
      // Convert object to array if it's not already an array
      recentPosts.value = Array.isArray(data) ? data : Object.values(data)
      // Sort by timestamp (newest first)
      recentPosts.value.sort((a, b) => b.timestamp - a.timestamp)
    } else {
      recentPosts.value = []
    }
  } catch (err) {
    console.error('Error fetching recent posts:', err)
    error.value = 'حدث خطأ في تحميل المنشورات الحديثة'
    recentPosts.value = []
  } finally {
    loading.value = false
  }
}

const handlePostClick = (post) => {
  if (post.type === 0) {
    // Article type - route to /article/:id
    router.push({ name: 'article', params: { id: post.id } })
  } else if (post.type === 1) {
    // Media type - route to /media/:id/:t
    router.push({ name: 'Media', params: { id: post.id, t: '0' } })
  }
}

const getTypeLabel = (type) => {
  return type === 0 ? 'مقال' : type === 1 ? 'وسائط' : 'غير محدد'
}

onMounted(() => {
  fetchRecentPosts()
})
</script>

<style scoped>
.recent-posts {
  padding: 15px;
  max-width: 300px;
  width: 100%;
}

.recent-title {
  color: var(--text-color);
  font-size: 1.2rem;
  font-weight: bold;
  margin-bottom: 15px;
  text-align: center;
}

.recent-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.recent-item {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 8px 12px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.2);
  min-height: 60px;
}

.recent-item:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.post-title {
  color: var(--text-color);
  font-weight: 500;
  font-size: 0.9rem;
  line-height: 1.3;
  margin-bottom: 5px;
  word-wrap: break-word;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.post-type {
  color: var(--scond-color);
  font-size: 0.7rem;
  font-weight: bold;
  padding: 3px 6px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  white-space: nowrap;
  align-self: flex-start;
}

.no-posts {
  color: var(--text-color);
  text-align: center;
  font-style: italic;
  padding: 20px;
  opacity: 0.7;
}

@media (max-width: 767px) {
  .recent-posts {
    margin: 0 auto;
  }
  
  .recent-list {
    grid-template-columns: 1fr;
    gap: 6px;
  }
  
  .recent-item {
    min-height: 50px;
    padding: 6px 10px;
  }
  
  .post-title {
    font-size: 0.85rem;
  }
  
  .post-type {
    font-size: 0.65rem;
    padding: 2px 5px;
  }
}
</style>
